import { VictimType } from 'typings/globalTypes';

export const getVictimFullName = (victim: VictimType) =>
  `${victim.firstName} ${victim.lastName}`;
